/* eslint-disable react/destructuring-assignment */
import { IconAtom, IconClearAll, IconQrcode, IconSearch } from '@tabler/icons-react';
import { Button, Grid, Group, Paper, Space, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import NumberFormat from 'react-number-format';

type FilterData = {
  residuo: string;
  codigoIBAMA: string;
};

type FilterProps = {
  filter(data: FilterData): void;
  clear(): void;
  loading: boolean;
};

function Filter(props: FilterProps) {
  const form = useForm<FilterData>({
    initialValues: {
      residuo: '',
      codigoIBAMA: '',
    },
  });

  return (
    <form onSubmit={form.onSubmit(props.filter)}>
      <Paper shadow="xs" p="md" withBorder>
        <Grid columns={5}>
          <Grid.Col span={2}>
            <TextInput
              leftSection={<IconAtom size={15} />}
              label="Resíduo"
              description="Filtro: contém"
              placeholder="Todos..."
              maxLength={500}
              {...form.getInputProps('residuo')}
            />
          </Grid.Col>
          <Grid.Col span={1}>
            <NumberFormat
              leftSection={<IconQrcode size={15} />}
              label="Código IBAMA"
              description="Filtro: começa com"
              placeholder="Todos..."
              mask="_"
              format="## ## ##"
              customInput={TextInput}
              {...form.getInputProps('codigoIBAMA')}
            />
          </Grid.Col>
          <Grid.Col span={2}>
            <Group>
              <Button
                style={{ marginTop: 44 }}
                color="secondary"
                leftSection={<IconClearAll size={18} />}
                disabled={props.loading}
                onClick={() => {
                  form.reset();
                  props.clear();
                }}
              >
                Limpar
              </Button>
              <Button
                style={{ marginTop: 44 }}
                leftSection={<IconSearch size={18} />}
                type="submit"
                loading={props.loading}
              >
                Pesquisar
              </Button>
            </Group>
          </Grid.Col>
        </Grid>
      </Paper>
      <Space h="xl" />
    </form>
  );
}

export { Filter };
export type { FilterData };
